import { register, findAll, find } from '../../../Javascript/Utils'

const component = el => {
  const componentPrefix = 'medacMoleculeAccordionitem'
  const accordionItems = findAll('.medacMoleculeAccordionitem', el)
  const collapseOthers = el.dataset.collapseothers
  accordionItems.forEach((accordionItem, index) => {
    const toggler = find(`.${componentPrefix}-header`, accordionItem)
    toggler.addEventListener('click', () => {
      if (collapseOthers) {
        accordionItems.forEach((accordionItemInner, innerIndex) => {
          if (innerIndex !== index) {
            accordionItemInner.classList.remove(`${componentPrefix}-open`)
          }
        })
      }
      accordionItem.classList.toggle(`${componentPrefix}-open`)
    })
  })
}

register('Accordion', component)
